
import { LanguageId } from "../core/types";
import { JS_HELP_ITEMS } from "./javascript";
import { PY_HELP_ITEMS } from "./python";
import { HelpCategory } from "./types";

export const HELP_REGISTRY: Record<LanguageId, HelpCategory[]> = {
    javascript: JS_HELP_ITEMS,
    python: PY_HELP_ITEMS,
};